var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { attrs: { id: "main-container" } },
        [
          _c(
            "van-pull-refresh",
            {
              class: _vm.noData,
              on: { refresh: _vm.onRefresh },
              model: {
                value: _vm.isLoading,
                callback: function($$v) {
                  _vm.isLoading = $$v
                },
                expression: "isLoading"
              }
            },
            [
              _c(
                "van-list",
                {
                  staticClass: "invoice-list",
                  attrs: { finished: _vm.finished, offset: 1 },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.ploading,
                    callback: function($$v) {
                      _vm.ploading = $$v
                    },
                    expression: "ploading"
                  }
                },
                [
                  _vm._l(_vm.list, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.merchantOrderNo,
                        staticClass: "invoice-item",
                        on: {
                          click: function($event) {
                            _vm.invoiceItemClick(item)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("商城消费")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info" }, [
                          _c("div", { staticClass: "price" }, [
                            _vm._v("¥" + _vm._s(item.totalAmount))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "type" }, [
                            _vm._v(_vm._s(item.depositTypeStr))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "timer" }, [
                          _vm._v(_vm._s(item.createTime))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "icon" }, [
                          _c("img", {
                            attrs: { src: _vm.getIcon(item), alt: "" }
                          })
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  !_vm.listShow
                    ? _c("div", { staticClass: "nogood" }, [
                        _c("img", { attrs: { src: _vm.noListUrl, alt: "" } }),
                        _vm._v(" "),
                        _c("p", [_vm._v("暂无发票")])
                      ])
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }